import TitleRow from '@/components/ui/TitleRow'

interface AccountPageHeaderProps {
  title: string
}

/**
 * The title row every Account sub-page opens with — `TitleRow` plus this
 * family's one shared fact: back always goes to `/profile`, never
 * `history.back()`. These pages are reachable from a pasted URL and from the
 * sidebar's ACCOUNT group alike, where there is no history to pop and the
 * button would either do nothing or leave the app.
 *
 * V1 of this component also drew the nine-tab `AccountTabs` strip under the
 * title. None of the 36 V2 Account frames draw an in-page strip any more —
 * the sidebar's own ACCOUNT group (Account/Edit Profile/Linked Accounts/Plan/
 * Notifications/Appearance/Security/Privacy/Help) replaced it as the family's
 * wayfinding — so that strip is gone, and `AccountTabs.tsx` with it.
 *
 * Not used by the Account hub itself (`ProfileScreen.tsx`): the hub is this
 * section's root and V2 draws no back chevron there, so it renders `TitleRow`
 * directly with no `back` prop instead of going through here.
 */
export default function AccountPageHeader({ title }: AccountPageHeaderProps) {
  return <TitleRow title={title} back="/profile" />
}
